exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lds-ring[data-v-45f119a6]{display:block;position:relative;width:80px;height:80px;margin:0 auto}.lds-ring div[data-v-45f119a6]{box-sizing:border-box;display:block;position:absolute;width:64px;height:64px;margin:8px;border-radius:50%;animation:lds-ring-45f119a6 1.2s cubic-bezier(.5,0,.5,1) infinite;border:8px solid transparent;border-top-color:#07132f}.lds-ring div[data-v-45f119a6]:first-child{animation-delay:-.45s}.lds-ring div[data-v-45f119a6]:nth-child(2){animation-delay:-.3s}.lds-ring div[data-v-45f119a6]:nth-child(3){animation-delay:-.15s}@keyframes lds-ring-45f119a6{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports
